(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(scope) {
    var reveals = scope.querySelectorAll('.c03-reveal:not([data-c03-reveal-ready])');
    if (!reveals.length) return;

    document.documentElement.classList.add('c03-motion-ready');

    Array.prototype.forEach.call(reveals, function (item) {
      item.setAttribute('data-c03-reveal-ready', 'true');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(reveals, function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -3%' });

    Array.prototype.forEach.call(reveals, function (item) {
      observer.observe(item);
    });
  }

  function initCardFraming(root) {
    if (root.c03CardFramingCleanup) return;
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-c03-art-center]'));
    if (!images.length) return;
    function update() {
      images.forEach(function (image) {
        var card = image.parentElement;
        var renderedWidth = Math.max(card.clientWidth, card.clientHeight * Number(image.getAttribute('width')) / Number(image.getAttribute('height')));
        var overflow = renderedWidth - card.clientWidth;
        var center = Number(image.dataset.c03ArtCenter);
        var zoom = Number(image.dataset.c03ArtZoom) || 1;
        if (zoom > 1) {
          // Extra crop gives an off-center portrait set room to move without exposing an edge.
          var shift = (.5 - center) * renderedWidth * zoom;
          image.style.objectPosition = '50% 50%';
          var shiftY = (Number(image.dataset.c03ArtOffsetY) || 0) * card.clientHeight + (Number(image.dataset.c03ArtOffsetYPx) || 0);
          image.style.transform = 'translate(' + shift.toFixed(3) + 'px, ' + shiftY.toFixed(3) + 'px) scale(' + zoom + ')';
          return;
        }
        var position = overflow > 0 ? Math.max(0, Math.min(1, (center * renderedWidth - card.clientWidth / 2) / overflow)) * 100 : 50;
        image.style.objectPosition = position.toFixed(3) + '% 50%';
      });
    }
    var observer;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(update);
      images.forEach(function (image) { observer.observe(image.parentElement); });
    } else window.addEventListener('resize', update, { passive: true });
    update();
    root.c03CardFramingCleanup = function () {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', update);
      delete root.c03CardFramingCleanup;
    };
  }

  function initCarousel(root) {
    if (!root || root.dataset.c03CarouselReady === 'true') return;

    var track = root.querySelector('[data-c03-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-c03-slide]')) : [];
    var current = root.querySelector('[data-c03-current]');
    var previous = root.querySelector('[data-c03-previous]');
    var next = root.querySelector('[data-c03-next]');

    if (!track || !slides.length) return;

    function closestSlideIndex() {
      var trackLeft = track.getBoundingClientRect().left;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateCurrent() {
      var activeIndex = closestSlideIndex();

      if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-current', index === activeIndex);
      });
    }

    function goToSlide(index) {
      var wrappedIndex = (index + slides.length) % slides.length;
      slides[wrappedIndex].scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }

    var scrollFrame = 0;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updateCurrent);
    }, { passive: true });

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goToSlide(closestSlideIndex() + (event.key === 'ArrowRight' ? 1 : -1));
    });

    if (previous) previous.addEventListener('click', function () {
      goToSlide(closestSlideIndex() - 1);
    });

    if (next) next.addEventListener('click', function () {
      goToSlide(closestSlideIndex() + 1);
    });

    updateCurrent();
    root.dataset.c03CarouselReady = 'true';
  }

  function initTransformation(root) {
    if (!root || root.dataset.c03TransformationReady === 'true') return;

    var stage = root.querySelector('.c03-transformation__stage');
    var scrollFrame = 0;
    var lastProgress = -1;

    if (!stage) return;

    root.dataset.c03TransformationReady = 'true';

    if (reduceMotion) {
      stage.style.setProperty('--c03-transformation-clip', '0%');
      return;
    }

    function update() {
      scrollFrame = 0;

      var bounds = stage.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var visibleBefore = Math.min(bounds.height * 0.92, viewportHeight * 0.6);
      var start = viewportHeight - visibleBefore;
      var end = Math.max(48, viewportHeight * 0.08);
      var progress = Math.max(0, Math.min(1, (start - bounds.top) / (start - end)));

      if (Math.abs(progress - lastProgress) < 0.001) return;

      var clip = (1 - progress) * 100;
      var lineOpacity = Math.min(1, progress / 0.06, (1 - progress) / 0.06);

      stage.style.setProperty('--c03-transformation-clip', clip.toFixed(3) + '%');
      stage.style.setProperty('--c03-transformation-line-opacity', lineOpacity.toFixed(3));
      lastProgress = progress;
    }

    function requestUpdate() {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();

    root.c03TransformationCleanup = function () {
      window.cancelAnimationFrame(scrollFrame);
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
    };
  }

  function initObjectLeaders(root) {
    var study = root && root.querySelector('.c03-object__study');
    if (!study || study.dataset.c03ObjectLeadersReady === 'true') return;

    var paths = study.querySelectorAll('.c03-object__leader-line');
    var canvasLabel = study.querySelector('.c03-object__callout--canvas');
    var frameLabel = study.querySelector('.c03-object__callout--frame');
    var desktopQuery = window.matchMedia && window.matchMedia('(min-width: 990px)');
    var resizeObserver = null;
    var resizeFrame = 0;
    var originalCanvasPath = 'M 41 14 H 54 L 48 47';
    var originalFramePath = 'M 52 112 H 81 L 92.5 58';

    if (paths.length < 2 || !canvasLabel || !frameLabel) return;

    study.dataset.c03ObjectLeadersReady = 'true';

    function coordinate(value, origin, extent, viewBoxExtent) {
      return ((value - origin) / extent * viewBoxExtent).toFixed(2);
    }

    function update() {
      resizeFrame = 0;

      if (!desktopQuery || !desktopQuery.matches) {
        paths[0].setAttribute('d', originalCanvasPath);
        paths[1].setAttribute('d', originalFramePath);
        return;
      }

      var studyBounds = study.getBoundingClientRect();
      var canvasBounds = canvasLabel.getBoundingClientRect();
      var frameBounds = frameLabel.getBoundingClientRect();

      if (!studyBounds.width || !studyBounds.height) return;

      var canvasX = coordinate(canvasBounds.right, studyBounds.left, studyBounds.width, 100);
      var canvasY = coordinate(canvasBounds.top + canvasBounds.height / 2, studyBounds.top, studyBounds.height, 125);
      var frameX = coordinate(frameBounds.left, studyBounds.left, studyBounds.width, 100);
      var frameY = coordinate(frameBounds.top + frameBounds.height / 2, studyBounds.top, studyBounds.height, 125);

      paths[0].setAttribute('d', 'M ' + canvasX + ' ' + canvasY + ' H 54 L 48 47');
      paths[1].setAttribute('d', 'M ' + frameX + ' ' + frameY + ' H 81 L 92.5 58');
    }

    function requestUpdate() {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(update);
    }

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(requestUpdate);
      resizeObserver.observe(study);
      resizeObserver.observe(canvasLabel);
      resizeObserver.observe(frameLabel);
    }

    window.addEventListener('resize', requestUpdate, { passive: true });
    window.requestAnimationFrame(update);

    study.c03ObjectLeadersCleanup = function () {
      window.cancelAnimationFrame(resizeFrame);
      window.removeEventListener('resize', requestUpdate);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }

  function initCollectionReturn(scope) {
    var roots = scope.querySelectorAll('[data-c03-bundle-shop]:not([data-c03-return-ready])');

    Array.prototype.forEach.call(roots, function (root) {
      var heading = root.querySelector('#c03-bundle-title');
      var grid = root.querySelector('.cr-grid');
      var dock = root.querySelector('[data-c03-return-dock]');
      var control = root.querySelector('[data-c03-return]');
      var scrollFrame = 0;
      var returnFrame = 0;
      var returnTimer = 0;
      var returning = false;

      if (!heading || !grid || !dock || !control) return;

      function update() {
        scrollFrame = 0;

        var gridBounds = grid.getBoundingClientRect();
        var rootBounds = root.getBoundingClientRect();
        var dockBounds = dock.getBoundingClientRect();
        var controlBounds = control.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var bottomOffset = 0;
        var fixedTop = viewportHeight - bottomOffset - controlBounds.height;
        if (returning && gridBounds.top > 24) returning = false;

        var shouldShow = !returning && gridBounds.top <= 24 && rootBounds.bottom > 0;
        var shouldDock = !returning && dockBounds.top <= fixedTop;

        if (shouldDock) {
          if (control.parentNode !== dock) dock.appendChild(control);
          control.classList.remove('is-floating');
          control.classList.add('is-visible', 'is-docked');
        } else if (shouldShow) {
          var wasVisible = control.classList.contains('is-visible');
          var wasDocked = control.classList.contains('is-docked');

          if (control.parentNode !== document.body) document.body.appendChild(control);
          control.classList.remove('is-docked');
          control.classList.add('is-floating');

          if (wasVisible || wasDocked) {
            control.classList.add('is-visible');
          } else {
            window.requestAnimationFrame(function () {
              if (control.classList.contains('is-floating')) control.classList.add('is-visible');
            });
          }
        } else {
          if (control.parentNode !== dock) dock.appendChild(control);
          control.classList.remove('is-visible', 'is-floating', 'is-docked');
        }
      }

      function requestUpdate() {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(update);
      }

      function alignCollectionHeading(behavior) {
        var headingTop = heading.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);

        window.scrollTo({
          top: Math.max(0, headingTop - 92),
          behavior: behavior
        });
      }

      function returnToSets(event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();
        returning = true;
        document.documentElement.classList.add('c03-return-layout-ready');
        control.classList.remove('is-visible');
        control.classList.remove('is-floating', 'is-docked');
        if (control.parentNode !== dock) dock.appendChild(control);
        window.clearTimeout(returnTimer);
        root.getBoundingClientRect();
        window.cancelAnimationFrame(returnFrame);
        returnFrame = window.requestAnimationFrame(function () {
          returnFrame = window.requestAnimationFrame(function () {
            returnFrame = 0;
            alignCollectionHeading(reduceMotion ? 'auto' : 'smooth');
            returnTimer = window.setTimeout(function () {
              returning = false;
              requestUpdate();
            }, reduceMotion ? 0 : 1000);
          });
        });
      }

      control.addEventListener('click', returnToSets);
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });

      root.classList.add('is-return-ready');
      root.setAttribute('data-c03-return-ready', 'true');
      window.requestAnimationFrame(update);

      root.c03CollectionReturnCleanup = function () {
        window.cancelAnimationFrame(scrollFrame);
        window.cancelAnimationFrame(returnFrame);
        window.clearTimeout(returnTimer);
        if (control.parentNode !== dock) dock.appendChild(control);
        control.classList.remove('is-visible', 'is-floating', 'is-docked');
        root.classList.remove('is-return-ready');
        document.documentElement.classList.remove('c03-return-layout-ready');
        control.removeEventListener('click', returnToSets);
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
      };
    });
  }

  function init(scope) {
    initReveals(scope);
    initCollectionReturn(scope);
    var editorials = scope.querySelectorAll('[data-c03-editorial]');

    if (editorials.length) document.documentElement.classList.add('c03-editorial-page');

    Array.prototype.forEach.call(editorials, function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-c03-transformation]'), initTransformation);
      initObjectLeaders(root);
      initCarousel(root);
      initCardFraming(root);

    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var hero = event.target.querySelector('[data-c03-hero]');
    var transformation = event.target.querySelector('[data-c03-transformation]');
    var objectStudy = event.target.querySelector('.c03-object__study');
    var editorial = event.target.querySelector('[data-c03-editorial]');
    var bundleShop = event.target.querySelector('[data-c03-bundle-shop]');
    if (hero && typeof hero.c03TransitionCleanup === 'function') hero.c03TransitionCleanup();
    if (transformation && typeof transformation.c03TransformationCleanup === 'function') transformation.c03TransformationCleanup();
    if (objectStudy && typeof objectStudy.c03ObjectLeadersCleanup === 'function') objectStudy.c03ObjectLeadersCleanup();
    if (bundleShop && typeof bundleShop.c03CollectionReturnCleanup === 'function') bundleShop.c03CollectionReturnCleanup();
    if (editorial && editorial.c03CardFramingCleanup) editorial.c03CardFramingCleanup();
    if (editorial) {
      window.requestAnimationFrame(function () {
        if (!document.querySelector('[data-c03-editorial]')) document.documentElement.classList.remove('c03-editorial-page');
      });
    }
  });
})();
